import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';


const ContactForm = () => {

    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = e => {
        // e.preventDefault();
        if (validator.allValid()) {
            validator.hideMessages();
            setForms({
                name: '',
                email: '',
                subject: '',
                phone: '',
                message: ''
            })
        } else {
            validator.showMessages();
        }
    };

    return (
        <form method="post" action="https://formspree.io/f/mnnjvkyo" className="contact-validation-active" onSubmit={(e) => submitHandler(e)} >
            <div className="row align-items-center">
                <div className="col-md-12">
                    <div className="form-group">
                        <label>Email*</label>
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            className="form-control"
                            id="contact-email"
                            required
                            placeholder="Your Email" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="fullwidth form-group">
                        <label>Message*</label>
                        <textarea
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            value={forms.message}
                            type="text"
                            name="message"
                            className="form-control"
                            id="contact-message"
                            required
                            placeholder="Message">
                        </textarea>
                        {validator.message('message', forms.message, 'required')}
                    </div>
                </div>
                <div className="col-md-5 order-md-1 order-2 col-12">
                    <div className="submit-area">
                        <button type="submit" className="theme-btn">Submit now</button>
                        <div id="loader">
                            <i className="ti-reload"></i>
                        </div>
                    </div>
                </div>
                <div className="col-md-7 order-md-2 order-1 col-12">
                    <div className="contact-info">
                        <ul>
                            {/* <li><i className="fi flaticon-phone-call"></i>
                                <a href="tel:19782951387" target='_blank' rel="noreferrer">+19782951387</a>
                            </li> */}
                            <li><i className="fi flaticon-mail"></i> 
                                <a href="mailto:yassermejri0988@gmail.com" target='_blank' rel="noreferrer">yassermejri0988@gmail.com</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </form>

    )
}

export default ContactForm;